// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../static/image/topaze-nouvelle-promotion-vente-vendre-achat-buy-sale-crans-montana-hypotheque-banque-emprunt-c7328fe8.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --black:#333;
  --white:#FFF;
  --light-grey:#F1F1F1;
  --medium-grey:#AAA;
  --primary: #FD4F00;
  --red: #FE5555;
  --green: #5BDCA0;
  --yellow:#FFCC00;
  --status-disponible-bg: #E3F5EC;
  --status-disponible-text: #1F8A5C;
  --status-reserve-bg: #FCF1DC;
  --status-reserve-text: #A66A16;
  --status-vendu-bg: #F2E7E7;
  --status-vendu-text: #8C5555;
  --heading-font: "Red Hat Display",'Open Sans';
  --main-font: 'Didact Gothic','Open Sans',sans-serif;
}

* {
  outline: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: var(--main-font);
  font-size: 16px;
  font-weight: 400;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  * {
    font-size: 14px;
  }
}

::-moz-selection { /* Code for Firefox */
  color: var(--white);
  background: var(--primary);
}

::selection {
  color: var(--white);
  background: var(--primary);
}

html {
  scroll-behavior: smooth;
  color: var(--black);
}

body {
  max-width: 1920px;
  margin: auto;
  overflow: overlay;
}

ul {
  list-style: none;
}

a {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  color: inherit;
  text-decoration: inherit;
  cursor: pointer;
}

button {
  border: none;
  background: none;
  cursor: pointer;
}

p {
  line-height: 1.6;
  letter-spacing: 1.2px;
}

span {
  font-size: 1em;
}

main, footer {
  position: relative;
  top: 75px;
}
@media (min-width: 1200px) {
  main, footer {
    top: 100px;
  }
}

/*---HEADING---*/
h1 {
  font-family: var(--heading-font);
  font-size: 60px;
  letter-spacing: 6px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  h1 {
    font-size: 50px;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  h1 {
    font-size: 130px;
  }
}

h2 {
  font-family: var(--heading-font);
  font-size: 35px;
  text-transform: uppercase;
  letter-spacing: 5px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  h2 {
    font-size: 30px;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  h2 {
    font-size: 70px;
  }
}

h3 {
  font-family: var(--heading-font);
  font-size: 25px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  h3 {
    font-size: 35px;
  }
}

h4 {
  font-family: var(--heading-font);
  font-size: 18px;
  letter-spacing: 4px;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  h4 {
    font-size: 15px;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  h4 {
    font-size: 20px;
  }
}

h5 {
  font-family: var(--heading-font);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 5px;
  opacity: 0.8;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  h5 {
    font-size: 12px;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  h5 {
    font-size: 16px;
  }
}

/*---COMMON---*/
.btn-show-more {
  position: relative;
  padding: 1rem;
  padding-left: 0;
  font-weight: 600;
  letter-spacing: 2px;
  overflow: hidden;
}
.btn-show-more:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 0%;
  height: 1px;
  background-color: var(--primary);
  transition: all 0.5s ease;
}
.btn-show-more:active {
  color: var(--primary);
}
@media (min-width: 1200px) {
  .btn-show-more {
    font-size: 18px;
  }
  .btn-show-more:hover {
    color: var(--primary);
  }
  .btn-show-more:hover::after {
    width: 100%;
    transition: all 0.5s ease;
  }
}

.btn {
  position: relative;
  font-family: var(--heading-font);
  font-size: 18px;
  letter-spacing: 5px;
  padding: 1rem 2rem;
  text-transform: uppercase;
  overflow: hidden;
  mix-blend-mode: exclusion;
  background: var(--light-grey);
  border: none;
  cursor: pointer;
}
.btn:not(:disabled):before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  transform: translateX(-105%);
  width: 100%;
  height: 100%;
  background-color: var(--white);
  mix-blend-mode: exclusion;
  transition: all 0.5s ease;
}
.btn:not(:disabled):after {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: var(--black);
  transition: all 0.5s ease;
}
.btn:active::before {
  transform: translateX(0%);
}
.btn:disabled {
  color: #FFF;
}
@media (min-width: 1200px) {
  .btn {
    font-size: 22px;
    padding: 1rem 3rem;
  }
  .btn:hover::before {
    transform: translateX(0%);
    transition: all 0.5s ease;
  }
  .btn:hover::after {
    width: 0px;
    background-color: var(--white);
    transition: all 0.5s ease;
  }
}

.btn-promotion {
  position: relative;
  font-family: var(--heading-font);
  font-size: 18px;
  letter-spacing: 4px;
  padding: 1rem;
  margin-top: 2rem;
  overflow: hidden;
  z-index: 1;
}
.btn-promotion:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  transform: translateX(-105%);
  width: 100%;
  height: 100%;
  background-color: var(--primary);
  z-index: -1;
  transition: all 0.5s ease;
}
.btn-promotion:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: var(--white);
  transition: all 0.5s ease;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  .btn-promotion {
    font-size: 15px;
  }
}
@media (min-width: 1200px) {
  .btn-promotion:hover::before {
    transform: translateX(0%);
  }
  .btn-promotion:hover::after {
    width: 0px;
    transition: all 0.5s ease;
  }
  .btn-promotion {
    font-size: 22px;
  }
  .btn-promotion:hover::before {
    transform: translateX(0%);
    transition: all 0.5s ease;
  }
}

.small-arrow {
  width: 29px;
  height: 29px;
  border-radius: 50px;
  background-color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  color: var(--black);
  cursor: pointer;
  transition: all 0.5s ease;
  opacity: 1;
}
.small-arrow:active {
  background-color: var(--primary);
  color: var(--white);
}
@media (min-width: 1200px) {
  .small-arrow {
    width: 40px;
    height: 40px;
  }
  .small-arrow:hover {
    background-color: var(--primary);
  }
  .small-arrow:hover path {
    fill: var(--white);
  }
}

.big-arrow {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  background: var(--white);
  color: var(--black);
  border-radius: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  z-index: 5;
  cursor: pointer;
}
@media (min-width: 1200px) {
  .big-arrow {
    width: 55px;
    height: 55px;
  }
}
.big-arrow svg {
  height: 65%;
}
@media (min-width: 1200px) {
  .big-arrow svg {
    height: 80%;
  }
}
.big-arrow.go-down {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translate(-50%) rotate(180deg);
}
@media (min-width: 1200px) {
  .big-arrow.go-down {
    bottom: 2rem;
  }
}
.big-arrow.go-up {
  bottom: 1rem;
  right: 1rem;
}
@media (min-width: 1200px) {
  .big-arrow.go-up {
    bottom: 2rem;
    right: 2rem;
  }
}
.big-arrow:hover {
  background: var(--primary);
  color: var(--white);
}

/*---SCROLL BAR---*/
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: var(--primary);
}

/*---NAVIGATION---*/
header {
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 75px;
  padding-left: 5%;
  background-color: var(--white);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  z-index: 10;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  header {
    height: 100px;
  }
}
@media (min-width: 1200px) {
  header {
    padding: 0 10%;
  }
}
header .logo {
  width: 150px;
  height: 75px;
  z-index: 10;
  display: flex;
  align-items: center;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  header .logo {
    width: 225px;
    height: 100px;
  }
}
header .logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
header nav {
  display: flex;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  z-index: 9;
  background-color: var(--white);
  opacity: 0;
  visibility: hidden;
  font-family: var(--heading-font);
}
@media (min-width: 1200px) {
  header nav {
    display: block;
    position: initial;
    width: auto;
    height: auto;
    transform: inherit;
    opacity: 1;
    visibility: visible;
  }
  header nav .navigation > li:hover {
    color: var(--primary);
  }
  header nav .navigation > li::before {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    height: 1px;
    width: 0px;
    background-color: var(--primary);
    transition: all 0.5s ease;
  }
  header nav .navigation > li:hover::before {
    width: 100%;
    transition: all 0.5s ease;
  }
}
header nav .navigation {
  width: 50%;
  margin: auto;
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  header nav .navigation {
    gap: 0;
  }
}
@media (min-width: 1200px) {
  header nav .navigation {
    gap: 2vw;
    width: 100%;
    margin: 0;
    flex-flow: row nowrap;
  }
}
header nav .navigation > li {
  position: relative;
  flex: 0 0 10%;
  width: 100%;
  text-align: center;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1.3px;
}
@media (min-width: 1200px) {
  header nav .navigation > li {
    width: auto;
    flex: 0 0 auto;
  }
}
header nav .navigation > li:active {
  color: var(--primary);
}
header nav a {
  padding: 1rem;
}
header .menu {
  width: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  header .menu {
    width: 100px;
  }
}
@media (min-width: 1200px) {
  header .menu {
    display: none;
  }
}
header li#lang {
  position: static;
  cursor: pointer;
  min-width: 60px;
  padding: 1rem;
}
@media (min-width: 1200px) {
  header li#lang {
    position: relative;
  }
  header li#lang:hover > ul {
    transform: translate(-50%, 0);
    opacity: 1;
    visibility: visible;
    transition: all 0.5s ease;
  }
}
header li#lang > ul {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  width: 100vw;
  padding: 0 30%;
  height: calc(100vh - 100px);
  background-color: var(--white);
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  z-index: 10;
}
@media (min-width: 1200px) {
  header li#lang > ul {
    margin: 0;
    gap: 0;
    top: 100%;
    left: 50%;
    width: max-content;
    min-width: 100%;
    padding: 0.5rem 0;
    height: auto;
    transform: translate(-50%, -200%);
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    z-index: -1;
  }
}
header li#lang li {
  color: var(--black);
  padding: 1rem;
  cursor: pointer;
}
header li#lang li:hover {
  background-color: var(--primary);
  color: var(--white);
}
header.header--dark {
  background-color: var(--black);
}
header.header--dark nav {
  background-color: var(--black);
}
header.header--dark .navigation > li {
  color: var(--white);
}
header.header--dark .navigation > li:hover, header.header--dark .navigation > li:active {
  color: rgba(255, 255, 255, 0.7);
}
header.header--dark .navigation > li::before {
  background-color: var(--white);
}
header.header--dark li#lang > span {
  color: var(--white);
}
header.header--dark li#lang > ul {
  background-color: var(--black);
}
header.header--dark li#lang > ul li {
  color: var(--white);
}
header.header--dark li#lang > ul li:hover {
  background-color: rgba(255, 255, 255, 0.15);
  color: var(--white);
}
header.header--dark #line_1, header.header--dark #line_2, header.header--dark #line_3 {
  stroke: var(--white);
}

/*---HEADER---*/
.section-header {
  position: relative;
  min-height: calc(100vh - 75px);
  height: auto;
  width: 100%;
  color: var(--black);
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  .section-header {
    height: auto;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .section-header {
    height: calc(100vh - 100px);
  }
}
@media (min-width: 1200px) {
  .section-header {
    max-height: 937px;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 65% 35%;
    color: var(--white);
  }
}
.section-header .header-image {
  height: 30vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  z-index: -1;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  .section-header .header-image {
    height: 200px;
  }
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .section-header .header-image {
    height: 50%;
  }
}
@media (min-width: 1200px) {
  .section-header .header-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 70%), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
.section-header > hgroup {
  width: 90%;
  margin: 1rem auto 0.5rem auto;
  position: relative;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-50px);
}
@media (min-width: 1200px) {
  .section-header > hgroup {
    align-self: flex-end;
    width: 80%;
  }
}
.section-header > hgroup p {
  font-size: 1rem;
}
@media (min-width: 1200px) {
  .section-header > hgroup p {
    font-size: 25px;
    margin-top: 3rem;
    width: 45%;
  }
}
.section-header .header-info {
  position: relative;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-50px);
  display: flex;
  flex-flow: column wrap;
  width: 90%;
  margin: auto;
}
@media (min-width: 1200px) {
  .section-header .header-info {
    width: 100%;
    flex-flow: row nowrap;
    width: 80%;
  }
}
.section-header .header-info hgroup {
  width: 100%;
  margin: 0.5rem 0;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2) and (max-width: 900px), only screen and (max--moz-device-pixel-ratio: 1) and (max-width: 900px), only screen and (-o-max-device-pixel-ratio: 2/1) and (max-width: 900px), only screen and (max-device-pixel-ratio: 2) and (max-width: 900px) {
  .section-header .header-info hgroup {
    margin: 0.35rem 0;
  }
}

/*---SECTION---*/
.feature-section {
  padding-top: 5rem;
}
@media (min-width: 1200px) {
  .feature-section {
    padding-top: 7rem;
  }
}

.section-title {
  position: relative;
  text-align: center;
  margin-bottom: 7rem;
}
@media (min-width: 1200px) {
  .section-title {
    margin-bottom: 10rem;
  }
}
.section-title:before {
  position: absolute;
  content: "";
  bottom: 0;
  height: 1px;
  background-color: var(--primary);
}
.section-title h2 {
  padding: 2rem 0;
}

.section-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/*---SECTION-PROJECT---*/
.section-project .section-title {
  --width:0;
}
.section-project .section-title::before {
  width: var(--width);
  left: 0;
}
@media (min-width: 1200px) {
  .section-project .project-block:nth-child(odd) {
    flex-flow: row-reverse;
  }
  .section-project .project-block:nth-child(odd) .block-text {
    padding-left: 192px;
  }
  .section-project .project-block:nth-child(even) .block-text {
    padding-right: 192px;
  }
  .section-project .project-block:nth-child(odd) .project-btn {
    left: 0;
    padding-left: 192px;
  }
  .section-project .project-block:nth-child(even) .project-btn {
    right: 0;
    padding-right: 192px;
  }
}
@media (min-width: 1200px) and (min-width: 1200px) {
  .section-project .project-block:nth-child(even) .project-btn {
    right: inherit;
  }
}

.project-block {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  margin-bottom: 3rem;
}
@media (min-width: 1200px) {
  .project-block {
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-bottom: 10rem;
  }
}
.project-block .block-image {
  width: 100%;
  object-fit: cover;
  object-position: 72% 50%;
  margin-bottom: 3rem;
}
@media (min-width: 1200px) {
  .project-block .block-image {
    position: sticky;
    top: 100px;
    height: 520px;
    width: 48%;
    margin-bottom: 0;
  }
}
.project-block .block-text {
  position: relative;
  width: 90%;
  margin: auto;
}
@media (min-width: 1200px) {
  .project-block .block-text {
    width: 48%;
    margin: 0;
    padding-bottom: 2rem;
  }
}
.project-block .block-text h3 {
  margin-bottom: 2rem;
}
@media (min-width: 1200px) {
  .project-block .block-text h3 {
    width: 85%;
  }
}
.project-block .block-text p {
  height: calc(12rem + 14.4px);
  overflow: hidden;
  overflow: hidden;
  margin-bottom: 3rem;
}
@media (min-width: 1200px) {
  .project-block .block-text p {
    height: calc(18rem + 21.6px);
    overflow: hidden;
  }
}
.project-block .project-btn {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: flex-end;
}
@media (min-width: 1200px) {
  .project-block .project-btn {
    position: absolute;
    bottom: 0;
    width: auto;
    justify-content: initial;
  }
}

/*---SECTION-COUNTERS---*/
.section-counters {
  background-color: var(--light-grey);
  padding: 5rem 0;
  margin-top: 5rem;
}
@media (min-width: 1200px) {
  .section-counters {
    display: flex;
  }
}
.section-counters div {
  width: 50%;
  margin: auto;
  text-align: center;
  padding: 2.5rem 0;
}
.section-counters span {
  display: block;
  font-size: 70px;
  margin-top: 1rem;
}
@media (min-width: 1200px) {
  .section-counters span {
    font-size: 100px;
  }
}

/*---SECTION-GALERIE---*/
.section-galerie .galerie {
  margin-bottom: 5rem;
}
@media (min-width: 1200px) {
  .section-galerie .galerie {
    height: 750px;
    overflow: hidden;
    margin-bottom: 8rem;
  }
}
.section-galerie .section-title {
  --width:0;
}
.section-galerie .section-title::before {
  width: var(--width);
  right: 0;
}
.section-galerie #main-carousel .splide__arrow {
  background: var(--white);
  opacity: 1;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .section-galerie #main-carousel .splide__arrow {
    width: 50px;
    height: 50px;
  }
}
.section-galerie #main-carousel .splide__arrow:active {
  background-color: var(--primary);
}
.section-galerie #main-carousel .splide__arrow:active svg {
  fill: var(--white);
}
.section-galerie #main-carousel .splide__arrow svg {
  width: 0.8rem;
  fill: var(--black);
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .section-galerie #main-carousel .splide__arrow svg {
    width: 1.2rem;
  }
}
@media (min-width: 1200px) {
  .section-galerie #main-carousel .splide__list {
    display: flex;
    flex-flow: row wrap;
  }
  .section-galerie #main-carousel .splide__slide {
    flex: 1 1 auto;
    height: 270px;
    overflow: hidden;
    cursor: pointer;
  }
  .section-galerie #main-carousel .splide__slide:hover img {
    transform: scale(1.2);
    transition: all 0.5s ease;
  }
  .section-galerie #main-carousel .splide__slide img {
    max-height: 100%;
    width: 100%;
    object-fit: cover;
    transition: all 0.5s ease;
  }
}
.section-galerie .section-btn {
  display: none;
}
@media (min-width: 1200px) {
  .section-galerie .section-btn {
    display: flex;
  }
}

.full-carousel-galerie {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: -1;
}
.full-carousel-galerie .xMark {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  color: var(--white);
  cursor: pointer;
}
@media (min-width: 1200px) {
  .full-carousel-galerie .xMark {
    right: 2rem;
  }
}
.full-carousel-galerie .splide__list {
  align-items: center;
}
.full-carousel-galerie .splide__slide {
  display: flex;
  align-items: center;
}
.full-carousel-galerie img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.full-carousel-galerie .carouselCounter {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  color: var(--white);
}
@media (min-width: 1200px) {
  .full-carousel-galerie .carouselCounter {
    right: 2rem;
  }
}
.full-carousel-galerie .splide__arrow {
  background: var(--white);
  opacity: 1;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .full-carousel-galerie .splide__arrow {
    width: 50px;
    height: 50px;
  }
}
.full-carousel-galerie .splide__arrow:active {
  background-color: var(--primary);
}
.full-carousel-galerie .splide__arrow:active svg {
  fill: var(--white);
}
.full-carousel-galerie .splide__arrow svg {
  width: 0.8rem;
  fill: var(--black);
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .full-carousel-galerie .splide__arrow svg {
    width: 1.2rem;
  }
}
@media (min-width: 1200px) {
  .full-carousel-galerie .small-arrow:hover {
    background-color: var(--primary);
  }
  .full-carousel-galerie .small-arrow:hover path {
    fill: var(--white);
  }
}

/*---SECTION-LOTS---*/
.section-list .section-title {
  --width:0;
}
.section-list .section-title::before {
  width: var(--width);
  left: 0;
}

.table {
  width: 100%;
  display: table;
  border-collapse: collapse;
  text-align: left;
  margin-bottom: 5rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .table {
    margin-bottom: 5rem;
  }
}
@media (min-width: 1200px) {
  .table {
    width: 80%;
    margin: auto;
    border-radius: 30px 30px 0 0;
    overflow: hidden;
  }
}
.table th {
  background-color: var(--primary);
  color: var(--white);
  font-size: 18px;
  font-family: var(--heading-font);
}
@media (min-width: 1200px) {
  .table th {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .table td {
    font-size: 18px;
  }
}
.table tr {
  position: relative;
  border-top: 1px solid var(--light-grey);
}
.table tr td:not(.article-status, .table-desktop-hide) {
  opacity: 0.5;
}
.table tr.availaible td {
  opacity: 1;
  font-weight: bold;
  background-color: var(--light-grey);
  border: none;
}
.table tr.availaible td span {
  font-weight: bold;
}
@media (min-width: 1200px) {
  .table tr.availaible:hover {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    z-index: 5;
    cursor: pointer;
  }
}
.table th:nth-child(6) {
  text-align: center;
}
.table th, .table td {
  min-width: 45px;
  min-height: 60px;
  padding: 1rem 0 1rem 1rem;
}
@media (min-width: 1200px) {
  .table th, .table td {
    text-transform: capitalize;
    padding: 1rem 2rem 1rem 2rem;
  }
}
.table .article-status > div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.table .article-status > div div {
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50px;
}
@media (min-width: 1200px) {
  .table .article-status > div div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 120px;
    padding: 0.5rem 1rem;
    font-weight: 600;
    font-size: 0.85rem;
    border-radius: 20px;
  }
}
.table .article-status > div div.availaible {
  background-color: var(--status-disponible-text);
}
@media (min-width: 1200px) {
  .table .article-status > div div.availaible {
    background-color: var(--status-disponible-bg);
    color: var(--status-disponible-text);
  }
}
.table .article-status > div div.sold {
  background-color: var(--status-vendu-text);
}
@media (min-width: 1200px) {
  .table .article-status > div div.sold {
    background-color: var(--status-vendu-bg);
    color: var(--status-vendu-text);
  }
}
.table .article-status > div div.reserved {
  background-color: var(--status-reserve-text);
}
@media (min-width: 1200px) {
  .table .article-status > div div.reserved {
    background-color: var(--status-reserve-bg);
    color: var(--status-reserve-text);
  }
}
.table tr.trInfo div {
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  height: 100%;
  gap: 1rem;
}
.table .article-info {
  position: relative;
  display: none;
  width: 100%;
  opacity: 0;
  visibility: hidden;
  padding-bottom: 1rem;
  background-color: var(--white);
  box-shadow: rgba(149, 157, 165, 0.2) 0px 25px 30px;
  border-bottom: 1px solid var(--medium-grey);
}
.table .article-info p {
  font-weight: bold;
}
.table .article-btn {
  width: 150px;
  height: 48px;
  border-radius: 50px;
  margin: 1rem 0 1rem 0;
  background-color: var(--primary);
  color: var(--white);
}
.table .article-btn:active {
  background-color: var(--white);
  border: solid 1px var(--primary);
  color: var(--primary);
}
.table .table-desktop-show {
  display: none;
}
@media (min-width: 1200px) {
  .table .table-desktop-show {
    display: table-cell;
  }
}
@media (min-width: 1200px) {
  .table .table-desktop-hide {
    display: none;
  }
}

/*---SECTION-LOCATION---*/
.section-location {
  margin-bottom: 5rem;
}
.section-location .section-title {
  --width:0;
}
.section-location .section-title::before {
  width: var(--width);
  right: 0;
}

.map {
  width: 100%;
  height: 545px;
}

.accordeon {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 93px;
  overflow: hidden;
  margin: auto;
  padding: 2rem 5%;
  border-bottom: 1px solid var(--primary);
}
@media (min-width: 1200px) {
  .accordeon {
    width: 80%;
    height: 136px;
    padding: 3rem 2rem;
    margin-top: 10rem;
    border-top: 1px solid var(--primary);
    cursor: pointer;
  }
  .accordeon:hover .small-arrow {
    transform: scale(1.2);
    transition: all 0.5s ease;
  }
}
.accordeon h4 {
  width: 80%;
  letter-spacing: 2px;
}
.accordeon .accordeon-info {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  height: auto;
  margin-top: 2rem;
  background-color: var(--white);
  z-index: 1;
}
@media (min-width: 1200px) {
  .accordeon .accordeon-info {
    flex-flow: row nowrap;
    margin-top: 5rem;
  }
}
.accordeon .accordeon-info > div {
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;
  margin-bottom: 2rem;
}
@media (min-width: 1200px) {
  .accordeon .accordeon-info > div {
    width: 50%;
  }
}
.accordeon .accordeon-info div div {
  display: flex;
  gap: 1rem;
}

/*---SECTION-CONTACT---*/
.section-contact {
  margin-bottom: 5rem;
}
@media (min-width: 1200px) {
  .section-contact {
    margin-bottom: 5rem;
  }
}
.section-contact .section-title {
  --width:0;
}
.section-contact .section-title::before {
  width: var(--width);
  left: 0;
}

.contact-block {
  width: 90%;
  margin: auto;
  display: flex;
  flex-flow: column wrap;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .contact-block {
    width: 60%;
  }
}
@media (min-width: 1200px) {
  .contact-block {
    width: 80%;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
}
.contact-block .contact-form {
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  gap: 1rem;
  padding: 1rem 0;
}
@media (min-width: 1200px) {
  .contact-block .contact-form {
    width: 48%;
    flex-flow: row wrap;
  }
}
.contact-block .contact-form .input-block {
  position: relative;
  width: 100%;
  min-height: 90px;
}
@media (min-width: 1200px) {
  .contact-block .contact-form .input-block {
    width: 48%;
  }
}
.contact-block .contact-form .input-block input, .contact-block .contact-form .input-block textarea {
  border: 1px solid var(--medium-grey);
  width: 100%;
  padding: 1rem;
}
.contact-block .contact-form .input-block input:focus, .contact-block .contact-form .input-block textarea:focus {
  border-color: var(--black);
}
.contact-block .contact-form .input-block textarea {
  min-height: 250px;
}
@media (min-width: 1200px) {
  .contact-block .contact-form .input-block textarea {
    width: 100%;
  }
}
@media (min-width: 1200px) {
  .contact-block .contact-form .input-block.textarea {
    width: 100%;
  }
}
.contact-block .contact-form .input-block label {
  padding: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.6;
}
.contact-block .contact-form .input-block span {
  color: var(--red);
}
.contact-block .contact-form .submit-block {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 3rem;
}
@media (min-width: 1200px) {
  .contact-block .contact-form .submit-block {
    justify-content: flex-end;
    margin-top: 2.5rem;
  }
}
.contact-block .contact-info {
  width: 100%;
  margin: 3rem 0;
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;
}
@media (min-width: 1200px) {
  .contact-block .contact-info {
    width: 45%;
    margin: 0;
  }
}
.contact-block .contact-info div {
  width: 100%;
  height: auto;
  display: flex;
  gap: 1rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .contact-block .contact-info div {
    justify-content: center;
  }
}
@media (min-width: 1200px) {
  .contact-block .contact-info div {
    justify-content: flex-start;
  }
}
.contact-block .contact-info svg {
  width: 18px;
}
.contact-block .contact-info .contact-logo {
  width: 100%;
  margin-bottom: 3rem;
}
@media only screen and (-webkit-max-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (max--moz-device-pixel-ratio: 2.1) and (min-width: 900px), only screen and (-o-max-device-pixel-ratio: 2.1/1) and (min-width: 900px), only screen and (max-device-pixel-ratio: 2.1) and (min-width: 900px) {
  .contact-block .contact-info .contact-logo {
    width: 60%;
    margin: auto;
    margin-bottom: 3rem;
  }
}
@media (min-width: 1200px) {
  .contact-block .contact-info .contact-logo {
    margin: 0;
  }
}
.contact-block .contact-info .contact-logo img {
  width: 100%;
  display: block;
}
.contact-block .contact-info .contact-logo.contact-logo--dark {
  background-color: var(--black);
  padding: 1.5rem;
  border-radius: 4px;
}

/*---SECTION-PROMOTIONS---*/
.section-promotions {
  color: var(--white);
}
.section-promotions .promotions-carousel .gradient {
  width: 100%;
  height: 100%;
  z-index: 1;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 100%);
}
.section-promotions .promotions-carousel .promotion {
  bottom: 0;
  position: absolute;
  width: 90%;
  margin: 0 10%;
  height: 60%;
  flex-flow: column;
  display: flex;
  align-items: flex-start;
}
@media (min-width: 1200px) {
  .section-promotions .promotions-carousel .promotion {
    height: 70%;
    width: 80%;
  }
}
.section-promotions .promotions-carousel img {
  background: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 70%);
}
.section-promotions .promotions-carousel .splide__pagination {
  gap: 1rem;
}
.section-promotions .promotions-carousel button.splide__pagination__page {
  width: 25px;
  border-radius: 0px;
  height: 4px;
}
.section-promotions .promotions-carousel button.splide__pagination__page.is-active {
  background-color: var(--primary);
  opacity: 1;
}
.section-promotions h2, .section-promotions h4 {
  width: 90%;
  word-break: keep-all;
}
.section-promotions h2 {
  margin-top: 2rem;
  max-width: 11ch;
}
@media (min-width: 1200px) {
  .section-promotions h2 {
    max-width: 18ch;
  }
}

/*---FOOTER---*/
.footer {
  text-align: center;
  padding: 1rem 0;
  background-color: var(--black);
  color: var(--white);
}
.footer p {
  font-size: 12px;
}
@media (min-width: 1200px) {
  .footer p {
    font-size: 16px;
  }
}
.footer a {
  display: inline;
}`, "",{"version":3,"sources":["webpack://./src/style.scss"],"names":[],"mappings":"AAuCA;EACI,YAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iCAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,4BAAA;EACA,6CAAA;EACA,mDAAA;AAtCJ;;AAyCA;EACI,UAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAtCJ;AAvBE;EAsDF;IASQ,eAAA;EApCN;AACF;;AAuCA,mBAAA,qBAAA;EACI,mBAAA;EACA,0BAAA;AApCJ;;AAuCE;EACE,mBAAA;EACA,0BAAA;AApCJ;;AAuCA;EACI,uBAAA;EACA,mBAAA;AApCJ;;AAuCA;EACI,iBAAA;EACA,YAAA;EACA,iBAAA;AApCJ;;AAuCA;EACI,gBAAA;AApCJ;;AAuCA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;EACA,eAAA;AApCJ;;AAuCA;EACI,YAAA;EACA,gBAAA;EACA,eAAA;AApCJ;;AAuCA;EACI,gBAAA;EACA,qBAAA;AApCJ;;AAuCA;EACI,cAAA;AApCJ;;AAuCA;EACI,kBAAA;EACA,SAAA;AApCJ;AA5DE;EA8FF;IAIQ,UAAA;EAlCN;AACF;;AAqCA,gBAAA;AAEA;EACI,gCAAA;EACA,eAAA;EACA,mBAAA;AAnCJ;AAhGE;EAgIF;IAKQ,eAAA;EAjCN;AACF;AA1FI;EAqHJ;IAQQ,gBAAA;EA/BN;AACF;;AAkCA;EACI,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AA/BJ;AAjHE;EA4IF;IAMQ,eAAA;EA7BN;AACF;AA3GI;EAiIJ;IASQ,eAAA;EA3BN;AACF;;AA8BA;EACI,gCAAA;EACA,eAAA;AA3BJ;AArHI;EA8IJ;IAIQ,eAAA;EAzBN;AACF;;AA4BA;EACI,gCAAA;EACA,eAAA;EACA,mBAAA;AAzBJ;AA3IE;EAiKF;IAKQ,eAAA;EAvBN;AACF;AArII;EAsJJ;IAQQ,eAAA;EArBN;AACF;;AAwBA;EACI,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AArBJ;AA7JE;EA6KF;IAOQ,eAAA;EAnBN;AACF;AAvJI;EAkKJ;IAUQ,eAAA;EAjBN;AACF;;AAoBA,eAAA;AAEA;EACI,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAlBJ;AAmBI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,yBAAA;AAjBR;AAmBI;EACI,qBAAA;AAjBR;AAtKE;EAqKF;IAqBQ,eAAA;EAhBN;EAiBM;IACI,qBAAA;EAfV;EAiBM;IACI,WAAA;IACA,yBAAA;EAfV;AACF;;AAmBA;EACI,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAhBJ;AAiBI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;AAfR;AAiBI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,yBAAA;AAfR;AAiBI;EACI,yBAAA;AAfR;AAiBI;EACI,WAAA;AAfR;AA5NE;EAqMF;IAyCQ,eAAA;IACA,kBAAA;EAdN;EAeM;IACI,yBAAA;IACA,yBAAA;EAbV;EAeM;IACI,UAAA;IACA,8BAAA;IACA,yBAAA;EAbV;AACF;;AAiBA;EACI,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAdJ;AAeI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,yBAAA;AAbR;AAeI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,yBAAA;AAbR;AApSE;EAoRF;IAgCQ,eAAA;EAZN;AACF;AAjRE;EA+RM;IACI,yBAAA;EAXV;EAaM;IACI,UAAA;IACA,yBAAA;EAXV;EA7BF;IA0CQ,eAAA;EAVN;EAWM;IACI,yBAAA;IACA,yBAAA;EATV;AACF;;AAaA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;AAVJ;AAWI;EACI,gCAAA;EACA,mBAAA;AATR;AApTE;EA8SF;IAkBQ,WAAA;IACA,YAAA;EARN;EASM;IACI,gCAAA;EAPV;EASM;IACI,kBAAA;EAPV;AACF;;AAWA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iDAAA;EACA,UAAA;EACA,eAAA;AARJ;AA/UE;EA2UF;IAcQ,WAAA;IACA,YAAA;EANN;AACF;AAOI;EACI,WAAA;AALR;AAxVE;EA4VE;IAGQ,WAAA;EAHV;AACF;AAKI;EACI,eAAA;EACA,YAAA;EACA,SAAA;EACA,yCAAA;AAHR;AAnWE;EAkWE;IAMQ,YAAA;EADV;AACF;AAGI;EACI,YAAA;EACA,WAAA;AADR;AA5WE;EA2WE;IAIQ,YAAA;IACA,WAAA;EACV;AACF;AACI;EACI,0BAAA;EACA,mBAAA;AACR;;AAGA,mBAAA;AAGA;EACI,WAAA;AAFJ;;AAKA;EACI,6BAAA;AAFJ;;AAKA;EACI,4BAAA;EACA,gCAAA;AAFJ;;AAMA,mBAAA;AAEA;EACI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,iDAAA;EACA,WAAA;AAJJ;AA/ZI;EAyZJ;IAYQ,aAAA;EAFN;AACF;AAvZE;EA4YF;IAeQ,cAAA;EAAN;AACF;AACI;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AACR;AAhbI;EA0aA;IAOQ,YAAA;IACA,aAAA;EAGV;AACF;AAFQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAIZ;AAAI;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,UAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;AAER;AA5bE;EA8aE;IAcQ,cAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;EAIV;EAHU;IACI,qBAAA;EAKd;EAHU;IACI,kBAAA;IACA,WAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,UAAA;IACA,gCAAA;IACA,yBAAA;EAKd;EAHU;IACI,WAAA;IACA,yBAAA;EAKd;AACF;AAHQ;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAKZ;AAvfE;EA6eM;IAOQ,MAAA;EAOd;AACF;AApeE;EAqdM;IAUQ,QAAA;IACA,WAAA;IACA,SAAA;IACA,qBAAA;EASd;AACF;AAPQ;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AASZ;AArfE;EAqeM;IASQ,WAAA;IACA,cAAA;EAWd;AACF;AARQ;EACI,qBAAA;AAUZ;AAPQ;EACI,aAAA;AASZ;AALI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAOR;AArhBI;EAygBA;IAOQ,YAAA;EASV;AACF;AA7gBE;EA4fE;IAUQ,aAAA;EAWV;AACF;AARI;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;AAUR;AAxhBE;EA0gBE;IAMQ,kBAAA;EAYV;EAXU;IACI,6BAAA;IACA,UAAA;IACA,mBAAA;IACA,yBAAA;EAad;AACF;AAXQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,2BAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AAaZ;AAtjBE;EAwhBM;IAmBQ,SAAA;IACA,MAAA;IACA,SAAA;IACA,SAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,YAAA;IACA,iCAAA;IACA,iDAAA;IACA,WAAA;EAed;AACF;AAbQ;EACI,mBAAA;EACA,aAAA;EACA,eAAA;AAeZ;AAbQ;EACI,gCAAA;EACA,mBAAA;AAeZ;AAXI;EACI,8BAAA;AAaR;AAZQ;EACI,8BAAA;AAcZ;AAZQ;EACI,mBAAA;AAcZ;AAbY;EACI,+BAAA;AAehB;AAbY;EACI,8BAAA;AAehB;AAXY;EACI,mBAAA;AAahB;AAXY;EACI,8BAAA;AAahB;AAZgB;EACI,mBAAA;AAcpB;AAZgB;EACI,2CAAA;EACA,mBAAA;AAcpB;AAVQ;EACI,oBAAA;AAYZ;;AAPA,eAAA;AAEA;EACI,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AASJ;AA9oBE;EAgoBF;IAOQ,YAAA;EAWN;AACF;AAxoBI;EAqnBJ;IAUQ,2BAAA;EAaN;AACF;AAhoBE;EAwmBF;IAaQ,iBAAA;IACA,aAAA;IACA,2BAAA;IACA,2BAAA;IACA,mBAAA;EAeN;AACF;AAdI;EACI,YAAA;EACA,mDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;AAgBR;AAzqBE;EAmpBE;IAQQ,aAAA;EAkBV;AACF;AAnqBI;EAwoBA;IAWQ,WAAA;EAoBV;AACF;AA3pBE;EA2nBE;IAcQ,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,wHACA;IAEA,4BAAA;IACA,sBAAA;IACA,2BAAA;EAoBV;AACF;AAlBI;EACI,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AAoBR;AAhrBE;EAspBE;IAQQ,oBAAA;IACA,UAAA;EAsBV;AACF;AArBQ;EACI,eAAA;AAuBZ;AAzrBE;EAiqBM;IAGQ,eAAA;IACA,gBAAA;IACA,UAAA;EAyBd;AACF;AAtBI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;AAwBR;AA1sBE;EA0qBE;IAUQ,WAAA;IACA,qBAAA;IACA,UAAA;EA0BV;AACF;AAzBQ;EACI,WAAA;EACA,gBAAA;AA2BZ;AA7uBE;EAgtBM;IAIQ,iBAAA;EA6Bd;AACF;;AAvBA,gBAAA;AAEA;EACI,iBAAA;AAyBJ;AA/tBE;EAqsBF;IAGQ,iBAAA;EA2BN;AACF;;AAxBA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;AA2BJ;AA1uBE;EA4sBF;IAKQ,oBAAA;EA6BN;AACF;AA5BI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;AA8BR;AA5BI;EACI,eAAA;AA8BR;;AA1BA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA6BJ;;AAzBA,wBAAA;AAGI;EACI,SAAA;AA0BR;AAzBQ;EACI,mBAAA;EACA,OAAA;AA2BZ;AAzwBE;EAkvBM;IACI,sBAAA;EA0BV;EAzBU;IACI,mBAAA;EA2Bd;EAvBU;IACI,oBAAA;EAyBd;EAtBM;IACI,OAAA;IACA,mBAAA;EAwBV;EAtBM;IACI,QAAA;IACA,oBAAA;EAwBV;AACF;AA5xBE;EAiwBM;IAIQ,cAAA;EA2Bd;AACF;;AAtBA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAyBJ;AAxyBE;EA2wBF;IAMQ,qBAAA;IACA,8BAAA;IACA,oBAAA;EA2BN;AACF;AA1BI;EACI,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;AA4BR;AArzBE;EAqxBE;IAMQ,gBAAA;IACA,UAAA;IACA,aAAA;IACA,UAAA;IACA,gBAAA;EA8BV;AACF;AA3BI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AA6BR;AAn0BE;EAmyBE;IAKQ,UAAA;IACA,SAAA;IACA,oBAAA;EA+BV;AACF;AA9BQ;EACI,mBAAA;AAgCZ;AA70BE;EA4yBM;IAGQ,UAAA;EAkCd;AACF;AAhCQ;EA5yBJ,4BAAA;EACA,gBAAA;EA6yBQ,gBAAA;EACA,mBAAA;AAmCZ;AAx1BE;EAkzBM;IA5yBJ,4BAAA;IACA,gBAAA;EAs1BF;AACF;AAlCI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AAoCR;AAp2BE;EA4zBE;IAMQ,kBAAA;IACA,SAAA;IACA,WAAA;IACA,wBAAA;EAsCV;AACF;;AAlCA,yBAAA;AAEA;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;AAoCJ;AAn3BE;EA40BF;IAKQ,aAAA;EAsCN;AACF;AArCI;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAuCR;AArCI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AAuCR;AAn4BE;EAy1BE;IAKQ,gBAAA;EAyCV;AACF;;AArCA,wBAAA;AAII;EACI,mBAAA;AAqCR;AA74BE;EAu2BE;IAGQ,aAAA;IACA,gBAAA;IACA,mBAAA;EAuCV;AACF;AArCI;EACI,SAAA;AAuCR;AAtCQ;EACI,mBAAA;EACA,QAAA;AAwCZ;AAnCQ;EACI,wBAAA;EACA,UAAA;AAqCZ;AA56BI;EAq4BI;IAIQ,WAAA;IACA,YAAA;EAuCd;AACF;AAtCY;EACI,gCAAA;AAwChB;AAtCY;EACI,kBAAA;AAwChB;AAtCY;EACI,aAAA;EACA,kBAAA;AAwChB;AA57BI;EAk5BQ;IAIQ,aAAA;EA0ClB;AACF;AAp7BE;EA+4BU;IACI,aAAA;IACA,mBAAA;EAwCd;EArCU;IACI,cAAA;IACA,aAAA;IACA,gBAAA;IACA,eAAA;EAuCd;EAtCc;IACI,qBAAA;IACA,yBAAA;EAwClB;EApCU;IACI,gBAAA;IACA,WAAA;IACA,iBAAA;IACA,yBAAA;EAsCd;AACF;AAlCI;EACI,aAAA;AAoCR;AA78BE;EAw6BE;IAGQ,aAAA;EAsCV;AACF;;AAlCA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,WAAA;AAqCJ;AApCI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAsCR;AAz+BE;EA67BE;IAQQ,WAAA;EAwCV;AACF;AAtCI;EACI,mBAAA;AAwCR;AAtCI;EACI,aAAA;EACA,mBAAA;AAwCR;AAtCI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAwCR;AAtCI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAwCR;AAhgCE;EAo9BE;IAMQ,WAAA;EA0CV;AACF;AAxCI;EACI,wBAAA;EACA,UAAA;AA0CR;AAthCI;EA0+BA;IAIQ,WAAA;IACA,YAAA;EA4CV;AACF;AA3CQ;EACI,gCAAA;AA6CZ;AA3CQ;EACI,kBAAA;AA6CZ;AA3CQ;EACI,aAAA;EACA,kBAAA;AA6CZ;AAtiCI;EAu/BI;IAIQ,aAAA;EA+Cd;AACF;AA9hCE;EAm/BM;IACI,gCAAA;EA8CV;EA5CM;IACI,kBAAA;EA8CV;AACF;;AA1CA,qBAAA;AAGI;EACI,SAAA;AA2CR;AA1CQ;EACI,mBAAA;EACA,OAAA;AA4CZ;;AAvCA;EACI,WAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AA0CJ;AApkCI;EAqhCJ;IAOQ,mBAAA;EA4CN;AACF;AA5jCE;EAwgCF;IAUQ,UAAA;IACA,YAAA;IACA,4BAAA;IACA,gBAAA;EA8CN;AACF;AA7CI;EACI,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AA+CR;AA1kCE;EAuhCE;IAMQ,eAAA;EAiDV;AACF;AA/kCE;EAiiCE;IAEQ,eAAA;EAgDV;AACF;AA7CI;EACI,kBAAA;EACA,uCAAA;AA+CR;AA5CI;EACI,YAAA;AA8CR;AA3CI;EACI,UAAA;EACA,iBAAA;EACA,mCAAA;EACA,YAAA;AA6CR;AA5CQ;EACI,iBAAA;AA8CZ;AApmCE;EA0jCE;IAEQ,2CAAA;IACA,UAAA;IACA,eAAA;EA4CV;AACF;AA1CI;EACI,kBAAA;AA4CR;AA1CI;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;AA4CR;AAnnCE;EAokCE;IAKQ,0BAAA;IACA,4BAAA;EA8CV;AACF;AA1CQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AA4CZ;AA1CQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA4CZ;AApoCE;EAolCM;IAMQ,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,YAAA;IACA,oBAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;EA8Cd;AACF;AA7CY;EACI,+CAAA;AA+ChB;AAppCE;EAomCU;IAGQ,6CAAA;IACA,oCAAA;EAiDlB;AACF;AAhDa;EACG,0CAAA;AAkDhB;AA7pCE;EA0mCW;IAGO,wCAAA;IACA,+BAAA;EAoDlB;AACF;AAlDY;EACI,4CAAA;AAoDhB;AAtqCE;EAinCU;IAGQ,0CAAA;IACA,iCAAA;EAsDlB;AACF;AAjDI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAmDR;AAhDI;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,8BAAA;EACA,kDAAA;EACA,2CAAA;AAkDR;AAjDQ;EACI,iBAAA;AAmDZ;AA/CI;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;AAiDR;AAhDQ;EACI,8BAAA;EACA,gCAAA;EACA,qBAAA;AAkDZ;AA9CI;EACI,aAAA;AAgDR;AAjtCE;EAgqCE;IAGQ,mBAAA;EAkDV;AACF;AAttCE;EAsqCE;IAEQ,aAAA;EAkDV;AACF;;AA7CA,yBAAA;AAEA;EACI,mBAAA;AA+CJ;AA9CI;EACI,SAAA;AAgDR;AA/CQ;EACI,mBAAA;EACA,QAAA;AAiDZ;;AA5CA;EACI,WAAA;EACA,aAAA;AA+CJ;;AA5CA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uCAAA;AA+CJ;AA1vCE;EAgsCF;IAaQ,UAAA;IACA,aAAA;IACA,kBAAA;IACA,iBAAA;IACA,oCAAA;IACA,eAAA;EAiDN;EAhDM;IACI,qBAAA;IACA,yBAAA;EAkDV;AACF;AAhDI;EACI,UAAA;EACA,mBAAA;AAkDR;AAhDI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,UAAA;AAkDR;AAtxCE;EA4tCE;IAUQ,qBAAA;IACA,gBAAA;EAoDV;AACF;AAnDQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAqDZ;AAlyCE;EAyuCM;IAMQ,UAAA;EAuDd;AACF;AArDQ;EACI,aAAA;EACA,SAAA;AAuDZ;;AAlDA,wBAAA;AAEA;EACI,mBAAA;AAoDJ;AAhzCE;EA2vCF;IAGQ,mBAAA;EAsDN;AACF;AArDI;EACI,SAAA;AAuDR;AAtDQ;EACI,mBAAA;EACA,OAAA;AAwDZ;;AAnDA;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAsDJ;AAh1CI;EAsxCJ;IAMQ,UAAA;EAwDN;AACF;AAx0CE;EAywCF;IASQ,UAAA;IACA,qBAAA;IACA,8BAAA;EA0DN;AACF;AAzDI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AA2DR;AAt1CE;EAsxCE;IAOQ,UAAA;IACA,mBAAA;EA6DV;AACF;AA5DQ;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AA8DZ;AAj2CE;EAgyCM;IAKQ,UAAA;EAgEd;AACF;AA/DY;EACI,oCAAA;EACA,WAAA;EACA,aAAA;AAiEhB;AAhEgB;EACI,0BAAA;AAkEpB;AA/DY;EACI,iBAAA;AAiEhB;AAj3CE;EA+yCU;IAGQ,WAAA;EAmElB;AACF;AAt3CE;EAqzCU;IAEQ,WAAA;EAmElB;AACF;AAjEY;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AAmEhB;AAjEY;EACI,iBAAA;AAmEhB;AAhEQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAkEZ;AA54CE;EAq0CM;IAOQ,yBAAA;IACA,kBAAA;EAoEd;AACF;AAjEI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAmER;AAz5CE;EAi1CE;IAOQ,UAAA;IACA,SAAA;EAqEV;AACF;AApEQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;AAsEZ;AAl7CI;EAw2CI;IAMQ,uBAAA;EAwEd;AACF;AA16CE;EA21CM;IASQ,2BAAA;EA0Ed;AACF;AAxEQ;EACI,WAAA;AA0EZ;AAxEQ;EACI,WAAA;EACA,mBAAA;AA0EZ;AAn8CI;EAu3CI;IAIQ,UAAA;IACA,YAAA;IACA,mBAAA;EA4Ed;AACF;AA77CE;EA02CM;IASQ,SAAA;EA8Ed;AACF;AA7EY;EACI,WAAA;EACA,cAAA;AA+EhB;AA7EY;EACI,8BAAA;EACA,eAAA;EACA,kBAAA;AA+EhB;;AAxEA,2BAAA;AAEA;EACI,mBAAA;AA0EJ;AAxEQ;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,gFAAA;AA0EZ;AAxEQ;EACI,SAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AA0EZ;AAh+CE;EA84CM;IAUQ,WAAA;IACA,UAAA;EA4Ed;AACF;AA1EQ;EACI,+EAAA;AA4EZ;AA1EQ;EACI,SAAA;AA4EZ;AAzEQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;AA2EZ;AA1EY;EACI,gCAAA;EACA,UAAA;AA4EhB;AAxEI;EACI,UAAA;EACA,oBAAA;AA0ER;AAxEI;EACI,gBAAA;EACA,eAAA;AA0ER;AA7/CE;EAi7CE;IAIQ,eAAA;EA4EV;AACF;;AAvEA,eAAA;AAEA;EACI,kBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AAyEJ;AAxEI;EACI,eAAA;AA0ER;AA7gDE;EAk8CE;IAGQ,eAAA;EA4EV;AACF;AA1EI;EACI,eAAA;AA4ER","sourcesContent":["$screen-sm-max: 900px; //900px to 1200px\r\n$screen-cp-min: 1200px; //1200px to xxx\r\n\r\n@mixin smartphoneMini {\r\n  @media\r\n  only screen and ( -webkit-max-device-pixel-ratio: 2) and  (max-width: #{$screen-sm-max} ),\r\n  only screen and ( max--moz-device-pixel-ratio: 1) and  (max-width: #{$screen-sm-max} ), \r\n  only screen and ( -o-max-device-pixel-ratio: 2 / 1) and  (max-width: #{$screen-sm-max} ),\r\n  only screen and ( max-device-pixel-ratio: 2) and  (max-width: #{$screen-sm-max} )\r\n  {\r\n      @content;\r\n  }\r\n}\r\n\r\n@mixin tablet {\r\n    @media\r\n    only screen and ( -webkit-max-device-pixel-ratio: 2.1) and  (min-width: #{$screen-sm-max} ),\r\n    only screen and ( max--moz-device-pixel-ratio: 2.1) and  (min-width: #{$screen-sm-max} ), \r\n    only screen and ( -o-max-device-pixel-ratio: 2.1 / 1) and  (min-width: #{$screen-sm-max} ),\r\n    only screen and ( max-device-pixel-ratio: 2.1) and  (min-width: #{$screen-sm-max} )\r\n        { \r\n        @content;\r\n    }\r\n}\r\n\r\n\r\n\r\n@mixin computer {\r\n  @media (min-width: #{$screen-cp-min}) {\r\n      @content;\r\n  }\r\n}\r\n\r\n@mixin line-clamp($lines, $line-height) {\r\n    height: calc($lines * 1rem + $lines * $line-height);\r\n    overflow: hidden;\r\n}\r\n\r\n\r\n:root{\r\n    --black:#333;\r\n    --white:#FFF;\r\n    --light-grey:#F1F1F1;\r\n    --medium-grey:#AAA;\r\n    --primary: #FD4F00;\r\n    --red: #FE5555;\r\n    --green: #5BDCA0;\r\n    --yellow:#FFCC00;\r\n    --status-disponible-bg: #E3F5EC;\r\n    --status-disponible-text: #1F8A5C;\r\n    --status-reserve-bg: #FCF1DC;\r\n    --status-reserve-text: #A66A16;\r\n    --status-vendu-bg: #F2E7E7;\r\n    --status-vendu-text: #8C5555;\r\n    --heading-font: \"Red Hat Display\",'Open Sans';\r\n    --main-font : 'Didact Gothic','Open Sans',sans-serif;\r\n}\r\n\r\n*{\r\n    outline: 0;\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n    font-family: var(--main-font);\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    @include smartphoneMini{\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n::-moz-selection { /* Code for Firefox */\r\n    color: var(--white);\r\n    background: var(--primary);\r\n  }\r\n  \r\n  ::selection {\r\n    color: var(--white);\r\n    background: var(--primary);\r\n  }\r\n\r\nhtml{\r\n    scroll-behavior: smooth;\r\n    color: var(--black);\r\n}\r\n\r\nbody{\r\n    max-width: 1920px;\r\n    margin: auto;\r\n    overflow: overlay;\r\n}\r\n  \r\nul{\r\n    list-style: none;\r\n}\r\n\r\na{\r\n    position: relative;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    font-size: 1em;\r\n    color: inherit;\r\n    text-decoration: inherit;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton{\r\n    border: none;\r\n    background: none;\r\n    cursor: pointer;\r\n}\r\n\r\np{\r\n    line-height: 1.6;\r\n    letter-spacing: 1.2px;\r\n}\r\n\r\nspan{\r\n    font-size: 1em;\r\n}\r\n\r\nmain,footer{\r\n    position: relative;\r\n    top: 75px;\r\n    @include computer {\r\n        top:100px;\r\n    }\r\n}\r\n\r\n/*---HEADING---*/\r\n\r\nh1{\r\n    font-family: var(--heading-font);\r\n    font-size: 60px;\r\n    letter-spacing: 6px;\r\n    @include smartphoneMini {\r\n        font-size: 50px;\r\n    }\r\n    @include tablet {\r\n        font-size: 130px;\r\n    }\r\n}\r\n\r\nh2{\r\n    font-family: var(--heading-font);\r\n    font-size: 35px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 5px;\r\n    @include smartphoneMini{\r\n        font-size: 30px;\r\n    }\r\n    @include tablet {\r\n        font-size: 70px;\r\n    }\r\n}\r\n\r\nh3{\r\n    font-family: var(--heading-font);\r\n    font-size: 25px;\r\n    @include tablet {\r\n        font-size: 35px;\r\n    }\r\n}\r\n\r\nh4{\r\n    font-family: var(--heading-font);\r\n    font-size: 18px;\r\n    letter-spacing: 4px;\r\n    @include smartphoneMini{\r\n        font-size: 15px;\r\n    }\r\n    @include tablet {\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\nh5{\r\n    font-family: var(--heading-font);\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 5px;\r\n    opacity: 0.8;\r\n    @include smartphoneMini {\r\n        font-size: 12px;\r\n    }\r\n    @include tablet {\r\n        font-size: 16px;\r\n    }\r\n}\r\n\r\n/*---COMMON---*/\r\n\r\n.btn-show-more{\r\n    position: relative;\r\n    padding: 1rem;\r\n    padding-left: 0;\r\n    font-weight: 600;\r\n    letter-spacing: 2px;\r\n    overflow: hidden;\r\n    &:after{\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 0%;\r\n        height: 1px;\r\n        background-color: var(--primary);\r\n        transition: all 0.5s ease;\r\n    }\r\n    &:active{\r\n        color: var(--primary);\r\n    }\r\n    @include computer{\r\n        font-size: 18px;\r\n        &:hover{\r\n            color: var(--primary);\r\n        }\r\n        &:hover::after{\r\n            width: 100%;\r\n            transition: all 0.5s ease;\r\n        }\r\n    }\r\n}\r\n\r\n.btn{\r\n    position: relative;\r\n    font-family: var(--heading-font);\r\n    font-size: 18px;\r\n    letter-spacing: 5px;\r\n    padding: 1rem 2rem;\r\n    text-transform: uppercase;\r\n    overflow: hidden;\r\n    mix-blend-mode: exclusion;\r\n    background: var(--light-grey);\r\n    border: none;\r\n    cursor: pointer;\r\n    &:not(:disabled):before{\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 0;\r\n        transform: translateX(-105%);\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: var(--white);\r\n        mix-blend-mode: exclusion;\r\n        transition: all 0.5s ease;\r\n    }\r\n    &:not(:disabled):after{\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        height: 1px;\r\n        background-color: var(--black);\r\n        transition: all 0.5s ease;\r\n    }\r\n    &:active::before{\r\n        transform: translateX(-0%);\r\n    }\r\n    &:disabled{\r\n        color: #FFF;\r\n    }\r\n    @include computer{\r\n        font-size: 22px;\r\n        padding: 1rem 3rem;\r\n        &:hover::before{\r\n            transform: translateX(-0%);\r\n            transition: all 0.5s ease;\r\n        }\r\n        &:hover::after{\r\n            width: 0px;\r\n            background-color: var(--white);\r\n            transition: all 0.5s ease;\r\n        }\r\n    }\r\n}\r\n\r\n.btn-promotion{\r\n    position: relative;\r\n    font-family: var(--heading-font);\r\n    font-size: 18px;\r\n    letter-spacing: 4px;\r\n    padding: 1rem;\r\n    margin-top: 2rem;\r\n    overflow: hidden;\r\n    z-index: 1;\r\n    &:before{\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        top: 0;\r\n        transform: translateX(-105%);\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: var(--primary);\r\n        z-index: -1;\r\n        transition: all 0.5s ease;\r\n    }\r\n    &:after{\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        height: 1px;\r\n        background-color: var(--white);\r\n        transition: all 0.5s ease;\r\n    }\r\n    @include smartphoneMini{\r\n        font-size: 15px;\r\n    }\r\n    @include computer{\r\n        &:hover::before{\r\n            transform: translateX(-0%);\r\n        }\r\n        &:hover::after{\r\n            width: 0px;\r\n            transition: all 0.5s ease;\r\n        }\r\n        font-size: 22px;\r\n        &:hover::before{\r\n            transform: translateX(-0%);\r\n            transition: all 0.5s ease;\r\n        }\r\n    }\r\n}\r\n\r\n.small-arrow{\r\n    width: 29px;\r\n    height: 29px;\r\n    border-radius: 50px;\r\n    background-color: var(--white);\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    color: var(--black);\r\n    cursor: pointer;\r\n    transition: all 0.5s ease;\r\n    opacity: 1;\r\n    &:active{\r\n        background-color: var(--primary);\r\n        color: var(--white);\r\n    }\r\n    @include computer {\r\n        width: 40px;\r\n        height: 40px;\r\n        &:hover{\r\n            background-color: var(--primary);\r\n        }\r\n        &:hover path{\r\n            fill: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n.big-arrow{\r\n    position: absolute;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 35px;\r\n    height: 35px;\r\n    background: var(--white);\r\n    color: var(--black);\r\n    border-radius: 50px;\r\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n    z-index: 5;\r\n    cursor: pointer;\r\n    @include computer{\r\n        width: 55px;\r\n        height: 55px;\r\n    }\r\n    & svg{\r\n        height: 65%;\r\n        @include computer {\r\n            height: 80%;\r\n        }\r\n    }\r\n    &.go-down{\r\n        position: fixed;\r\n        bottom: 1rem;\r\n        left: 50%;\r\n        transform: translate(-50%) rotate(180deg);\r\n        @include computer{\r\n            bottom: 2rem;\r\n        }\r\n    }\r\n    &.go-up{\r\n        bottom: 1rem;\r\n        right: 1rem; \r\n        @include computer {\r\n            bottom: 2rem;\r\n            right: 2rem; \r\n        }   \r\n    }\r\n    &:hover{\r\n        background: var(--primary);\r\n        color: var(--white);\r\n    }\r\n}\r\n\r\n/*---SCROLL BAR---*/\r\n\r\n\r\n::-webkit-scrollbar {\r\n    width: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background-color: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background-clip: padding-box;\r\n    background-color: var(--primary);\r\n}\r\n\r\n\r\n/*---NAVIGATION---*/\r\n\r\nheader{\r\n    position: fixed;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 75px;\r\n    padding-left: 5%;\r\n    background-color: var(--white);\r\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n    z-index: 10;\r\n    @include tablet {\r\n        height: 100px;\r\n    }\r\n    @include computer() {\r\n        padding: 0 10%;\r\n    }\r\n    & .logo{\r\n        width: 150px;\r\n        height: 75px;\r\n        z-index: 10;\r\n        display: flex;\r\n        align-items: center;\r\n        @include tablet {\r\n            width: 225px;\r\n            height: 100px;\r\n        }\r\n        & img{\r\n            width: 100%;\r\n            height: 100%;\r\n            object-fit: contain;\r\n        }\r\n    }\r\n\r\n    & nav{\r\n        display: flex;\r\n        position: absolute;\r\n        width: 100vw;\r\n        height: 100vh;\r\n        top: 0;\r\n        left: 0;\r\n        transform: translateY(-100%);\r\n        z-index: 9;\r\n        background-color:var(--white);\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        font-family: var(--heading-font);\r\n        @include computer {\r\n            display: block;\r\n            position: initial;\r\n            width: auto;\r\n            height: auto;\r\n            transform: inherit;\r\n            opacity: 1;\r\n            visibility: visible;\r\n            & .navigation>li:hover{\r\n                color: var(--primary);\r\n            }\r\n            & .navigation>li::before{\r\n                position: absolute;\r\n                content: \"\";\r\n                bottom: 0;\r\n                left: 0;\r\n                height: 1px;\r\n                width: 0px;\r\n                background-color: var(--primary);\r\n                transition: all 0.5s ease;\r\n            }\r\n            & .navigation>li:hover::before{\r\n                width: 100%;\r\n                transition: all 0.5s ease;\r\n            }\r\n        }\r\n        & .navigation{\r\n            width: 50%;\r\n            margin: auto;\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            gap: 1rem;\r\n            @include smartphoneMini{\r\n                gap: 0;\r\n            }\r\n            @include computer {\r\n                gap: 2vw;\r\n                width: 100%;\r\n                margin: 0;\r\n                flex-flow: row nowrap;\r\n            }\r\n        }\r\n        & .navigation>li{\r\n            position: relative;\r\n            flex: 0 0 10%;\r\n            width: 100%;\r\n            text-align: center;\r\n            font-size: 18px;\r\n            text-transform: uppercase;\r\n            letter-spacing: 1.3px;\r\n            @include computer {\r\n                width: auto;\r\n                flex: 0 0 auto;\r\n            }\r\n        }\r\n\r\n        & .navigation>li:active{\r\n            color: var(--primary);\r\n        }\r\n\r\n        & a{\r\n            padding: 1rem;\r\n        }\r\n    }\r\n\r\n    & .menu{\r\n        width: 75px;\r\n        display:flex;\r\n        justify-content:center;\r\n        align-items:center;\r\n        z-index: 10;\r\n        @include tablet {\r\n            width: 100px;\r\n        }\r\n        @include computer() {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    & li#lang{\r\n        position: static;\r\n        cursor: pointer;\r\n        min-width: 60px;\r\n        padding: 1rem;\r\n        @include computer{\r\n            position: relative;\r\n            &:hover>ul{\r\n                transform: translate(-50%, 0);\r\n                opacity: 1;\r\n                visibility: visible;\r\n                transition: all 0.5s ease;\r\n            }\r\n        }\r\n        &>ul{\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n            transform: translateY(-100%);\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            justify-content: center;\r\n            align-items: center;\r\n            margin-top: 50px;\r\n            width: 100vw;\r\n            padding: 0 30%;\r\n            height: calc(100vh - 100px);\r\n            background-color: var(--white);\r\n            opacity: 0;\r\n            visibility: hidden;\r\n            transition: all 0.5s ease;\r\n            z-index: 10;\r\n            @include computer {\r\n                margin: 0;\r\n                gap: 0;\r\n                top: 100%;\r\n                left: 50%;\r\n                width: max-content;\r\n                min-width: 100%;\r\n                padding: 0.5rem 0;\r\n                height: auto;\r\n                transform: translate(-50%, -200%);\r\n                box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n                z-index: -1;\r\n            }\r\n        }\r\n        & li{\r\n            color: var(--black);\r\n            padding: 1rem;\r\n            cursor: pointer;\r\n        }\r\n        & li:hover{\r\n            background-color: var(--primary);\r\n            color: var(--white);\r\n        }\r\n    }\r\n\r\n    &.header--dark{\r\n        background-color: var(--black);\r\n        & nav{\r\n            background-color: var(--black);\r\n        }\r\n        & .navigation>li{\r\n            color: var(--white);\r\n            &:hover, &:active{\r\n                color: rgba(255,255,255,0.7);\r\n            }\r\n            &::before{\r\n                background-color: var(--white);\r\n            }\r\n        }\r\n        & li#lang{\r\n            &>span{\r\n                color: var(--white);\r\n            }\r\n            &>ul{\r\n                background-color: var(--black);\r\n                & li{\r\n                    color: var(--white);\r\n                }\r\n                & li:hover{\r\n                    background-color: rgba(255,255,255,0.15);\r\n                    color: var(--white);\r\n                }\r\n            }\r\n        }\r\n        & #line_1, & #line_2, & #line_3{\r\n            stroke: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n/*---HEADER---*/\r\n\r\n.section-header{\r\n    position: relative;\r\n    min-height: calc(100vh - 75px);\r\n    height: auto;\r\n    width: 100%;\r\n    color: var(--black);\r\n    @include smartphoneMini{\r\n        height: auto;\r\n    }\r\n    @include tablet {\r\n        height: calc(100vh - 100px);\r\n    }\r\n    @include computer {\r\n        max-height: 937px;\r\n        display: grid;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 65% 35%;\r\n        color: var(--white);\r\n    }\r\n    & .header-image{\r\n        height: 30vh;\r\n        background:url(\"../static/image/topaze-nouvelle-promotion-vente-vendre-achat-buy-sale-crans-montana-hypotheque-banque-emprunt-c7328fe8.png\");\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n        z-index: -1;\r\n        @include smartphoneMini{\r\n            height: 200px;\r\n        }\r\n        @include tablet {\r\n            height: 50%;\r\n        }\r\n        @include computer {\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n            width: 100%;\r\n            height: 100%;\r\n            background:\r\n            linear-gradient( to right,rgba(0,0,0,0.5), rgba(0,0,0,0) 70%),\r\n            url(\"../static/image/topaze-nouvelle-promotion-vente-vendre-achat-buy-sale-crans-montana-hypotheque-banque-emprunt-c7328fe8.png\");\r\n            background-repeat: no-repeat;\r\n            background-size: cover;\r\n            background-position: center;    \r\n        }\r\n    }\r\n    &>hgroup{\r\n        width: 90%;\r\n        margin: 1rem auto 0.5rem auto;\r\n        position: relative;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transform: translateY(-50px);\r\n        @include computer {\r\n            align-self: flex-end;\r\n            width: 80%;\r\n        }\r\n        & p{\r\n            font-size: 1rem;\r\n            @include computer {\r\n                font-size: 25px;\r\n                margin-top: 3rem;\r\n                width: 45%;\r\n            }\r\n        }\r\n    }\r\n    & .header-info{\r\n        position: relative;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transform: translateY(-50px);\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        width: 90%;\r\n        margin: auto;\r\n        @include computer {\r\n            width: 100%;\r\n            flex-flow: row nowrap;\r\n            width: 80%;\r\n        }\r\n        & hgroup{\r\n            width: 100%;\r\n            margin: 0.5rem 0;\r\n            @include smartphoneMini {\r\n                margin: 0.35rem 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/*---SECTION---*/\r\n\r\n.feature-section{\r\n    padding-top: 5rem;\r\n    @include computer {\r\n        padding-top: 7rem;\r\n    }\r\n}\r\n\r\n.section-title{\r\n    position: relative;\r\n    text-align: center;\r\n    margin-bottom: 7rem;\r\n    @include computer {\r\n        margin-bottom: 10rem;\r\n    }\r\n    &:before{\r\n        position: absolute;\r\n        content: \"\";\r\n        bottom: 0;\r\n        height: 1px;\r\n        background-color: var(--primary);\r\n    }\r\n    & h2{\r\n        padding: 2rem 0;\r\n    }\r\n}\r\n\r\n.section-btn{\r\n    width: 100%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n}\r\n\r\n\r\n/*---SECTION-PROJECT---*/\r\n\r\n.section-project{\r\n    & .section-title{\r\n        --width:0;\r\n        &::before{\r\n            width:var(--width);\r\n            left: 0;\r\n        }\r\n    }\r\n    @include computer {\r\n        & .project-block:nth-child(odd){\r\n            flex-flow: row-reverse;\r\n            & .block-text{\r\n                padding-left: calc(1920px*10/100);\r\n            }\r\n        }\r\n        & .project-block:nth-child(even){\r\n            & .block-text{\r\n                padding-right: calc(1920px*10/100);\r\n            }\r\n        }\r\n        & .project-block:nth-child(odd) .project-btn{\r\n            left: 0;\r\n            padding-left: calc(1920px*10/100);\r\n        }\r\n        & .project-block:nth-child(even) .project-btn{\r\n            right: 0;\r\n            padding-right: calc(1920px*10/100);\r\n            @include computer {\r\n                right: inherit;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.project-block{\r\n    position: relative;\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    margin-bottom: 3rem;\r\n    @include computer {\r\n        flex-flow: row nowrap;\r\n        justify-content: space-between; \r\n        margin-bottom: 10rem;\r\n    }\r\n    & .block-image{\r\n        width: 100%;\r\n        object-fit: cover;\r\n        object-position: 72% 50%;\r\n        margin-bottom: 3rem;\r\n        @include computer {\r\n            position: sticky;\r\n            top: 100px;    \r\n            height: 520px;\r\n            width: 48%;\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n\r\n    & .block-text{\r\n        position: relative;\r\n        width: 90%;\r\n        margin: auto;\r\n        @include computer {\r\n            width: 48%;\r\n            margin: 0;\r\n            padding-bottom: 2rem;\r\n        }\r\n        & h3{\r\n            margin-bottom: 2rem;\r\n            @include computer {\r\n                width: 85%\r\n            }\r\n        }\r\n        & p{\r\n            @include line-clamp(12,1.2px);\r\n            overflow: hidden;\r\n            margin-bottom: 3rem;\r\n            @include computer {\r\n                @include line-clamp(18,1.2px);\r\n            }\r\n        }\r\n    }\r\n\r\n    & .project-btn{\r\n        width: 100%;\r\n        margin: auto;\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        @include computer {\r\n            position: absolute;\r\n            bottom: 0;\r\n            width: auto;\r\n            justify-content: initial;\r\n        }\r\n    }\r\n}\r\n\r\n/*---SECTION-COUNTERS---*/\r\n\r\n.section-counters{\r\n    background-color: var(--light-grey);\r\n    padding: 5rem 0;\r\n    margin-top: 5rem;\r\n    @include computer {\r\n        display: flex;\r\n    }\r\n    & div{\r\n        width: 50%;\r\n        margin: auto;\r\n        text-align: center;\r\n        padding: 2.5rem 0;\r\n    }\r\n    & span{\r\n        display: block;\r\n        font-size: 70px;\r\n        margin-top: 1rem;\r\n        @include computer {\r\n            font-size: 100px;\r\n        }\r\n    }\r\n}\r\n\r\n/*---SECTION-GALERIE---*/\r\n\r\n\r\n.section-galerie{\r\n    & .galerie{\r\n        margin-bottom: 5rem;\r\n        @include computer {\r\n            height: 750px;\r\n            overflow: hidden;\r\n            margin-bottom: 8rem;\r\n        }\r\n    }\r\n    & .section-title{\r\n        --width:0;\r\n        &::before{\r\n            width: var(--width);\r\n            right: 0;\r\n        }\r\n    }\r\n\r\n    #main-carousel{\r\n        & .splide__arrow{\r\n            background: var(--white);\r\n            opacity: 1;\r\n            @include tablet {\r\n                width: 50px;\r\n                height: 50px;\r\n            }\r\n            &:active{\r\n                background-color: var(--primary);\r\n            }\r\n            &:active svg{\r\n                fill: var(--white);\r\n            }\r\n            & svg{\r\n                width: 0.8rem;\r\n                fill: var(--black);\r\n                @include tablet {\r\n                    width: 1.2rem;\r\n                }\r\n            }\r\n        }\r\n\r\n        @include computer {\r\n            &  .splide__list{\r\n                display: flex;\r\n                flex-flow: row wrap;\r\n            }\r\n\r\n            & .splide__slide{\r\n                flex: 1 1 auto;\r\n                height: 270px;\r\n                overflow: hidden;\r\n                cursor: pointer;\r\n                &:hover img{\r\n                    transform: scale(1.2);\r\n                    transition: all 0.5s ease;\r\n                }\r\n            }\r\n    \r\n            & .splide__slide img{\r\n                max-height: 100%;\r\n                width: 100%;\r\n                object-fit: cover;\r\n                transition: all 0.5s ease;\r\n            }\r\n        }\r\n    }\r\n\r\n    .section-btn{\r\n        display: none;\r\n        @include computer {\r\n            display: flex;\r\n        }\r\n    }\r\n}\r\n\r\n.full-carousel-galerie{\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n    z-index: -1;\r\n    & .xMark{\r\n        position: absolute;\r\n        top: 1rem;\r\n        right: 1rem;\r\n        width: 2rem;\r\n        color: var(--white);\r\n        cursor: pointer;\r\n        @include computer {\r\n            right: 2rem;\r\n        }\r\n    }\r\n    & .splide__list{\r\n        align-items: center;\r\n    }\r\n    & .splide__slide{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    & img{\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: contain;\r\n    } \r\n    & .carouselCounter{\r\n        position: absolute;\r\n        bottom: 1rem;\r\n        right: 1rem;\r\n        color: var(--white);\r\n        @include computer {\r\n            right: 2rem;\r\n        }\r\n    }\r\n    & .splide__arrow{\r\n        background: var(--white);\r\n        opacity: 1;\r\n        @include tablet {\r\n            width: 50px;\r\n            height: 50px;\r\n        }\r\n        &:active{\r\n            background-color: var(--primary);\r\n        }\r\n        &:active svg{\r\n            fill: var(--white);\r\n        }\r\n        & svg{\r\n            width: 0.8rem;\r\n            fill: var(--black);\r\n            @include tablet {\r\n                width: 1.2rem;\r\n            }\r\n        }\r\n    }\r\n    @include computer {\r\n        & .small-arrow:hover{\r\n            background-color: var(--primary);\r\n        }\r\n        & .small-arrow:hover path{\r\n            fill: var(--white);\r\n        }\r\n    }\r\n}\r\n\r\n/*---SECTION-LOTS---*/\r\n\r\n.section-list{\r\n    & .section-title{\r\n        --width:0;\r\n        &::before{\r\n            width: var(--width);\r\n            left: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.table{\r\n    width: 100%;\r\n    display: table;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n    margin-bottom: 5rem;\r\n    @include tablet {\r\n        margin-bottom: 5rem;\r\n    }\r\n    @include computer {\r\n        width: 80%;\r\n        margin: auto;\r\n        border-radius: 30px 30px 0 0;\r\n        overflow: hidden;\r\n    }\r\n    & th {\r\n        background-color: var(--primary);\r\n        color: var(--white);\r\n        font-size: 18px;\r\n        font-family: var(--heading-font);   \r\n        @include computer {\r\n            font-size: 22px;\r\n        }  \r\n    }\r\n\r\n    & td{\r\n        @include computer {\r\n            font-size: 18px;\r\n        }\r\n    }\r\n\r\n    & tr{\r\n        position: relative;\r\n        border-top: 1px solid var(--light-grey);\r\n    }\r\n    \r\n    & tr td:not(.article-status, .table-desktop-hide){\r\n        opacity: 0.5; \r\n    }\r\n    \r\n    & tr.availaible td{\r\n        opacity: 1;\r\n        font-weight: bold;\r\n        background-color: var(--light-grey);\r\n        border: none;\r\n        & span{\r\n            font-weight: bold;\r\n        }\r\n    }\r\n\r\n    & tr.availaible:hover{\r\n        @include computer{\r\n            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n            z-index: 5;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n    & th:nth-child(6){\r\n        text-align: center;\r\n    }\r\n    & th,td{\r\n        min-width: 45px;\r\n        min-height: 60px;\r\n        padding: 1rem 0 1rem 1rem;\r\n        @include computer {\r\n            text-transform: capitalize;\r\n            padding: 1rem 2rem 1rem 2rem;\r\n        }\r\n    }\r\n\r\n    & .article-status{\r\n        &>div{\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;            \r\n        }\r\n        &>div div{\r\n            display: block;\r\n            width: 12px;\r\n            height: 12px;\r\n            border-radius: 50px;\r\n            @include computer {\r\n                display:flex;\r\n                justify-content:center;\r\n                align-items:center;\r\n                height: auto;\r\n                width: 120px;\r\n                padding: 0.5rem 1rem;\r\n                font-weight: 600;\r\n                font-size: 0.85rem;\r\n                border-radius: 20px;\r\n            }\r\n            &.availaible{\r\n                background-color: var(--status-disponible-text);\r\n                @include computer {\r\n                    background-color: var(--status-disponible-bg);\r\n                    color: var(--status-disponible-text);\r\n                }\r\n            }&.sold{\r\n                background-color: var(--status-vendu-text);\r\n                @include computer {\r\n                    background-color: var(--status-vendu-bg);\r\n                    color: var(--status-vendu-text);\r\n                }\r\n            }\r\n            &.reserved{\r\n                background-color: var(--status-reserve-text);\r\n                @include computer {\r\n                    background-color: var(--status-reserve-bg);\r\n                    color: var(--status-reserve-text);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    & tr.trInfo div{\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        width: 100%;\r\n        height: 100%;\r\n        gap: 1rem;\r\n    }\r\n\r\n    & .article-info{\r\n        position: relative;\r\n        display: none;\r\n        width: 100%;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        padding-bottom: 1rem;\r\n        background-color: var(--white);\r\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 25px 30px;\r\n        border-bottom: 1px solid var(--medium-grey);\r\n        & p{\r\n            font-weight: bold;\r\n        }\r\n    }\r\n\r\n    & .article-btn{\r\n        width: 150px;\r\n        height: 48px;\r\n        border-radius: 50px;\r\n        margin: 1rem 0 1rem 0;\r\n        background-color: var(--primary);\r\n        color: var(--white);\r\n        &:active{\r\n            background-color: var(--white);\r\n            border: solid 1px var(--primary);\r\n            color: var(--primary);\r\n        }\r\n    }\r\n\r\n    & .table-desktop-show{\r\n        display: none;\r\n        @include computer {\r\n            display: table-cell;\r\n        }\r\n    }\r\n    & .table-desktop-hide{\r\n        @include computer {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/*---SECTION-LOCATION---*/\r\n\r\n.section-location{\r\n    margin-bottom: 5rem;\r\n    & .section-title{\r\n        --width:0;\r\n        &::before{\r\n            width: var(--width);\r\n            right: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.map{\r\n    width: 100%;\r\n    height: 545px;\r\n}\r\n\r\n.accordeon{\r\n    position: relative;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 93px;\r\n    overflow: hidden;\r\n    margin: auto;\r\n    padding: 2rem 5%;\r\n    border-bottom: 1px solid var(--primary);\r\n    @include computer {\r\n        width: 80%;\r\n        height: 136px;\r\n        padding: 3rem 2rem;\r\n        margin-top: 10rem;\r\n        border-top: 1px solid var(--primary);    \r\n        cursor: pointer;\r\n        &:hover .small-arrow{\r\n            transform: scale(1.2);\r\n            transition: all 0.5s ease\r\n        }\r\n    }\r\n    & h4{\r\n        width: 80%;\r\n        letter-spacing: 2px;\r\n    }\r\n    & .accordeon-info{\r\n        position: relative;\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        width: 100%;\r\n        height: auto;\r\n        margin-top: 2rem;\r\n        background-color: var(--white);\r\n        z-index: 1;\r\n        @include computer {\r\n            flex-flow: row nowrap;\r\n            margin-top: 5rem;\r\n        }\r\n        &>div{\r\n            display: flex;\r\n            flex-flow: column wrap;\r\n            gap: 1rem;\r\n            margin-bottom: 2rem;\r\n            @include computer {\r\n                width: 50%;\r\n            }\r\n        }\r\n        & div div{\r\n            display: flex;\r\n            gap: 1rem;\r\n        }\r\n    }\r\n}\r\n\r\n/*---SECTION-CONTACT---*/\r\n\r\n.section-contact{\r\n    margin-bottom: 5rem;\r\n    @include computer {\r\n        margin-bottom: 5rem;\r\n    }\r\n    & .section-title{\r\n        --width:0;\r\n        &::before{\r\n            width: var(--width);\r\n            left: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.contact-block{\r\n    width: 90%;\r\n    margin: auto;\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    @include tablet {\r\n        width: 60%;\r\n    }\r\n    @include computer {\r\n        width: 80%;\r\n        flex-flow: row nowrap;\r\n        justify-content: space-between;\r\n    }\r\n    & .contact-form{\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        width: 100%;\r\n        gap: 1rem;\r\n        padding: 1rem 0;\r\n        @include computer {\r\n            width: 48%;\r\n            flex-flow: row wrap;\r\n        }\r\n        & .input-block{\r\n            position: relative;\r\n            width: 100%;\r\n            min-height: 90px;\r\n            @include computer {\r\n                width: 48%;\r\n            }\r\n            & input, textarea{\r\n                border: 1px solid var(--medium-grey);\r\n                width: 100%;\r\n                padding: 1rem;\r\n                &:focus{\r\n                    border-color: var(--black);\r\n                }\r\n            }\r\n            & textarea{\r\n                min-height: 250px;\r\n                @include computer {\r\n                    width: 100%;\r\n                }\r\n            }\r\n            &.textarea{\r\n                @include computer {\r\n                    width: 100%;\r\n                }\r\n            }\r\n            & label{\r\n                padding: 1rem;\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                opacity: 0.6;\r\n            }\r\n            & span{\r\n                color: var(--red);\r\n            }\r\n        }\r\n        & .submit-block{\r\n            display:flex;\r\n            justify-content:center;\r\n            align-items:center;\r\n            width: 100%;\r\n            margin-top: 3rem;\r\n            @include computer {\r\n                justify-content: flex-end;\r\n                margin-top: 2.5rem;\r\n            }\r\n        }\r\n    }\r\n    & .contact-info{\r\n        width: 100%;\r\n        margin: 3rem 0;\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n        gap: 1rem;\r\n        @include computer {\r\n            width:45%;\r\n            margin: 0;\r\n        }\r\n        & div{\r\n            width: 100%;\r\n            height: auto;\r\n            display: flex;\r\n            gap: 1rem;\r\n            @include tablet {\r\n                justify-content: center;\r\n            }\r\n            @include computer {\r\n                justify-content: flex-start;\r\n            }\r\n        }\r\n        & svg{\r\n            width: 18px;\r\n        }\r\n        & .contact-logo{\r\n            width: 100%;\r\n            margin-bottom: 3rem;\r\n            @include tablet {\r\n                width: 60%;\r\n                margin: auto;\r\n                margin-bottom: 3rem;\r\n            }\r\n            @include computer {\r\n                margin: 0 ;\r\n            }\r\n            & img{\r\n                width: 100%;\r\n                display: block;\r\n            }\r\n            &.contact-logo--dark{\r\n                background-color: var(--black);\r\n                padding: 1.5rem;\r\n                border-radius: 4px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n/*---SECTION-PROMOTIONS---*/\r\n\r\n.section-promotions{\r\n    color: var(--white);\r\n    & .promotions-carousel{\r\n        & .gradient{\r\n            width: 100%;\r\n            height: 100%;\r\n            z-index: 1;\r\n            background:linear-gradient( to right,rgba(0,0,0,0.5), rgba(0,0,0,0) 100%);\r\n        }\r\n        & .promotion{\r\n            bottom: 0;\r\n            position: absolute;\r\n            width: 90%;\r\n            margin: 0 10%;\r\n            height: 60%;\r\n            flex-flow: column;\r\n            display: flex;\r\n            align-items: flex-start;\r\n            @include computer {\r\n                height: 70%;\r\n                width: 80%;\r\n            }\r\n        }\r\n        & img{\r\n            background: linear-gradient( to right,rgba(0,0,0,0.5), rgba(0,0,0,0) 70%);\r\n        }\r\n        & .splide__pagination{\r\n            gap: 1rem;\r\n        }\r\n\r\n        & button.splide__pagination__page {\r\n            width: 25px;\r\n            border-radius: 0px;\r\n            height: 4px;\r\n            &.is-active{\r\n                background-color: var(--primary);\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n    & h2,h4{\r\n        width: 90%;\r\n        word-break: keep-all;\r\n    }\r\n    & h2{\r\n        margin-top: 2rem;\r\n        max-width: 11ch;\r\n        @include computer{\r\n            max-width: 18ch;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/*---FOOTER---*/\r\n\r\n.footer{\r\n    text-align: center;\r\n    padding: 1rem 0;\r\n    background-color: var(--black);\r\n    color: var(--white);\r\n    & p{\r\n        font-size: 12px;\r\n        @include computer{\r\n            font-size: 16px;\r\n        }\r\n    }\r\n    & a{\r\n        display: inline;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
